import * as ui from "../native";
import React, { ReactNode } from "react";
import { DomUtils } from "../utils/DomUtils";
import { BuildContext } from "../classes/BuildContext";

export class StyleThemeData {
  public readonly themeName: string;
  public readonly color: ui.Color;
  public readonly textStyle: ui.TextStyle;
  public readonly tooltipBackgroundColor: ui.Color;
  public readonly tooltipTextColor: ui.Color;
  public static EdgeTheme: StyleThemeData;
  public readonly c1: ui.Color;
  public readonly c2: ui.Color;
  public readonly c3: ui.Color;
  public readonly c4: ui.Color;
  public readonly c5: ui.Color;
  public readonly c6: ui.Color;
  public readonly c7: ui.Color;
  public readonly c8: ui.Color;
  public readonly c9: ui.Color;
  public readonly c10: ui.Color;
  public readonly c11: ui.Color;
  public readonly c12: ui.Color;
  public readonly c13: ui.Color;
  public readonly c14: ui.Color;
  public readonly c15: ui.Color;
  public readonly c16: ui.Color;
  public readonly c17: ui.Color;
  public readonly c18: ui.Color;
  public readonly c19: ui.Color;
  public readonly c20: ui.Color;
  public readonly c21: ui.Color;
  public readonly c22: ui.Color;
  public readonly c23: ui.Color;
  public readonly c24: ui.Color;
  public readonly c25: ui.Color;
  public readonly c26: ui.Color;
  public readonly c27: ui.Color;
  public readonly tTextViewMapTextColorOn: ui.Color;
  public readonly tTextViewMapTextFontSizeOn: number;
  public readonly tTextViewPickerTextColorOn: ui.Color;
  public readonly tTextViewPickerTextFontSizeOn: number;
  public readonly tTextViewLauncherTextColorOn: ui.Color;
  public readonly tTextViewLauncherTextFontSizeOn: number;
  public readonly tTextViewStripeBlueColorOn: ui.Color;
  public readonly tTextViewStripeBlueFontSizeOn: number;
  public readonly tTextViewBlue11ColorOn: ui.Color;
  public readonly tTextViewBlue11FontSizeOn: number;
  public readonly tBaseBetweenMarginMarginOn: ui.EdgeInsets;
  public readonly tBaseCardDecorationOn: ui.BoxDecoration;
  public readonly tBaseCardMarginsMarginOn: ui.EdgeInsets;
  public readonly tBaseCardPaddingPaddingOn: ui.EdgeInsets;
  public readonly tIconButtonDefaultIconButtonDecorationOn: ui.BoxDecoration;
  public readonly tIconButtonDefaultIconButtonPaddingOn: ui.EdgeInsets;
  public readonly tIconButtonDefaultIconButtonConstraintsOn: ui.BoxConstraints;
  public readonly tIconButtonDefaultIconButtonColorOn: ui.Color;
  public readonly tIconButtonDefaultIconButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tIconButtonDefaultIconButtonPaddingOnHover: ui.EdgeInsets;
  public readonly tIconButtonDefaultIconButtonConstraintsOnHover: ui.BoxConstraints;
  public readonly tIconButtonDefaultIconButtonTextStyleOnHover: ui.TextStyle;
  public readonly tIconButtonDefaultIconButtonColorOnHover: ui.Color;
  public readonly tInputFieldDefaultInputFieldHeightOn: number;
  public readonly tInputFieldDefaultInputFieldBackgroundColorOn: ui.Color;
  public readonly tInputFieldDefaultInputFieldPlaceHolderColorOn: ui.Color;
  public readonly tInputFieldDefaultInputFieldInActiveColorOn: ui.Color;
  public readonly tInputFieldDefaultInputFieldStyleOn: ui.TextStyle;
  public readonly tInputFieldDefaultInputFieldActiveColorOn: ui.Color;
  public readonly tInputFieldDefaultInputFieldPaddingOn: ui.EdgeInsets;
  public readonly tInputFieldDefaultInputFieldCornerRadiusOn: number;
  public readonly tBaseDefaultPopUpDecorationOn: ui.BoxDecoration;
  public readonly tTextViewDescriptionTextFontSizeOn: number;
  public readonly tTextViewDescriptionTextFontWeightOn: ui.FontWeight;
  public readonly tTextViewDisplayHeadingOneFontSizeOn: number;
  public readonly tTextViewDisplayHeadingOneMarginOn: ui.EdgeInsets;
  public readonly tTextViewDisplayHeadingOneFontWeightOn: ui.FontWeight;
  public readonly tTextViewDropDownBuilderTextColorOn: ui.Color;
  public readonly tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets;
  public readonly tTextViewErrorTextColorOn: ui.Color;
  public readonly tTextViewErrorTextTextAlignOn: ui.TextAlign;
  public readonly tTextViewErrorTextMarginOn: ui.EdgeInsets;
  public readonly tColumnFieldStyleCrossAxisAlignmentOn: ui.CrossAxisAlignment;
  public readonly tColumnFieldStyleMarginOn: ui.EdgeInsets;
  public readonly tTextViewHeaderTextFontSizeOn: number;
  public readonly tTextViewHeaderTextFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadlineFiveFontSizeOn: number;
  public readonly tTextViewHeadlineFiveFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadlineFourFontSizeOn: number;
  public readonly tTextViewHeadlineFourFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadlineOneFontSizeOn: number;
  public readonly tTextViewHeadlineOneFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadlineSixFontSizeOn: number;
  public readonly tTextViewHeadlineSixFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadlineThreeFontSizeOn: number;
  public readonly tTextViewHeadlineThreeFontWeightOn: ui.FontWeight;
  public readonly tTextViewHeadlineTwoFontSizeOn: number;
  public readonly tTextViewHeadlineTwoFontWeightOn: ui.FontWeight;
  public readonly tTextViewInfoTextFontSizeOn: number;
  public readonly tTextViewInfoTextFontWeightOn: ui.FontWeight;
  public readonly tColumnJobDetailCardDecorationOn: ui.BoxDecoration;
  public readonly tColumnJobDetailCardPaddingOn: ui.EdgeInsets;
  public readonly tColumnJobDetailsPopupBGPaddingOn: ui.EdgeInsets;
  public readonly tColumnJobDetailsPopupBGDecorationOn: ui.BoxDecoration;
  public readonly tTextViewLabelTextFontSizeOn: number;
  public readonly tTextViewLabelTextFontWeightOn: ui.FontWeight;
  public readonly tTextViewLabelTextColorOn: ui.Color;
  public readonly tBaseLightColorWithMarginDecorationOn: ui.BoxDecoration;
  public readonly tBaseLightColorWithMarginMarginOn: ui.EdgeInsets;
  public readonly tButtonLinkButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonPlainPrimaryButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonPlainPrimaryButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonPlainSecondaryButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonPlainSecondaryButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonPlainSecondaryButtonPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonPlainSecondaryButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonPrimaryDecorationOn: ui.BoxDecoration;
  public readonly tButtonPrimaryPaddingOn: ui.EdgeInsets;
  public readonly tButtonPrimaryTextStyleOn: ui.TextStyle;
  public readonly tButtonPrimaryConstraintsOn: ui.BoxConstraints;
  public readonly tButtonPrimaryDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonPrimaryPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonPrimaryConstraintsOnHover: ui.BoxConstraints;
  public readonly tButtonPrimaryTextStyleOnHover: ui.TextStyle;
  public readonly tButtonPrimaryButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonPrimaryButtonHeightOn: number;
  public readonly tButtonPrimaryButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonPrimaryButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonPrimaryButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonPrimaryButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonPrimaryButtonPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonPrimaryButtonHeightOnHover: number;
  public readonly tButtonPrimaryButtonConstraintsOnHover: ui.BoxConstraints;
  public readonly tButtonPrimaryButtonTextStyleOnHover: ui.TextStyle;
  public readonly tButtonPrimaryOutlineDecorationOn: ui.BoxDecoration;
  public readonly tButtonPrimaryOutlinePaddingOn: ui.EdgeInsets;
  public readonly tButtonPrimaryOutlineTextStyleOn: ui.TextStyle;
  public readonly tButtonPrimaryOutlineConstraintsOn: ui.BoxConstraints;
  public readonly tButtonPrimaryOutlinePaddingOnHover: ui.EdgeInsets;
  public readonly tButtonPrimaryOutlineDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonPrimaryOutlineConstraintsOnHover: ui.BoxConstraints;
  public readonly tButtonPrimaryOutlineTextStyleOnHover: ui.TextStyle;
  public readonly tColumnProjectCardDecorationOn: ui.BoxDecoration;
  public readonly tColumnProjectCardPaddingOn: ui.EdgeInsets;
  public readonly tRowProjectCard2DecorationOn: ui.BoxDecoration;
  public readonly tRowProjectCard2PaddingOn: ui.EdgeInsets;
  public readonly tColumnResumeBGColorDecorationOn: ui.BoxDecoration;
  public readonly tColumnResumeBGColorPaddingOn: ui.EdgeInsets;
  public readonly tInputFieldSearchInputFieldInActiveColorOn: ui.Color;
  public readonly tInputFieldSearchInputFieldPlaceHolderColorOn: ui.Color;
  public readonly tInputFieldSearchInputFieldActiveColorOn: ui.Color;
  public readonly tInputFieldSearchInputFieldPaddingOn: ui.EdgeInsets;
  public readonly tInputFieldSearchInputFieldCornerRadiusOn: number;
  public readonly tButtonSecondaryDecorationOn: ui.BoxDecoration;
  public readonly tButtonSecondaryPaddingOn: ui.EdgeInsets;
  public readonly tButtonSecondaryConstraintsOn: ui.BoxConstraints;
  public readonly tButtonSecondaryTextStyleOn: ui.TextStyle;
  public readonly tButtonSecondaryDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonSecondaryPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonSecondaryConstraintsOnHover: ui.BoxConstraints;
  public readonly tButtonSecondaryTextStyleOnHover: ui.TextStyle;
  public readonly tBaseSelectedTabContainerHeightOn: number;
  public readonly tBaseSelectedTabContainerWidthOn: number;
  public readonly tBaseSelectedTabContainerDecorationOn: ui.BoxDecoration;
  public readonly tBaseShadowForContainerDecorationOn: ui.BoxDecoration;
  public readonly tBaseShadowStyleDecorationOn: ui.BoxDecoration;
  public readonly tTextViewTabsFontSizeOn: number;
  public readonly tTextViewTabsFontWeightOn: ui.FontWeight;
  public readonly tButtonUnderLineButtonTextStyleOn: ui.TextStyle;
  public readonly tBaseViewPaddingPaddingOn: ui.EdgeInsets;
  public readonly tButtonWarningButtonDecorationOn: ui.BoxDecoration;
  public readonly tButtonWarningButtonPaddingOn: ui.EdgeInsets;
  public readonly tButtonWarningButtonTextStyleOn: ui.TextStyle;
  public readonly tButtonWarningButtonConstraintsOn: ui.BoxConstraints;
  public readonly tButtonWarningButtonDecorationOnHover: ui.BoxDecoration;
  public readonly tButtonWarningButtonPaddingOnHover: ui.EdgeInsets;
  public readonly tButtonWarningButtonConstraintsOnHover: ui.BoxConstraints;
  public readonly tButtonWarningButtonTextStyleOnHover: ui.TextStyle;
  public readonly tBaseWebBetweenMarginMarginOn: ui.EdgeInsets;
  public readonly tBaseWebPaddingPaddingOn: ui.EdgeInsets;
  public readonly tBaseWidgetPaddingPaddingOn: ui.EdgeInsets;
  public static current: StyleThemeData;
  public constructor(
    d3eParams?: Partial<{
      themeName: string;
      color: ui.Color;
      textStyle: ui.TextStyle;
      tooltipBackgroundColor: ui.Color;
      tooltipTextColor: ui.Color;
      tTextViewMapTextColorOn: ui.Color;
      tTextViewMapTextFontSizeOn: number;
      tTextViewPickerTextColorOn: ui.Color;
      tTextViewPickerTextFontSizeOn: number;
      tTextViewLauncherTextColorOn: ui.Color;
      tTextViewLauncherTextFontSizeOn: number;
      tTextViewStripeBlueColorOn: ui.Color;
      tTextViewStripeBlueFontSizeOn: number;
      tTextViewBlue11ColorOn: ui.Color;
      tTextViewBlue11FontSizeOn: number;
      tBaseBetweenMarginMarginOn: ui.EdgeInsets;
      tBaseCardDecorationOn: ui.BoxDecoration;
      tBaseCardMarginsMarginOn: ui.EdgeInsets;
      tBaseCardPaddingPaddingOn: ui.EdgeInsets;
      tIconButtonDefaultIconButtonDecorationOn: ui.BoxDecoration;
      tIconButtonDefaultIconButtonPaddingOn: ui.EdgeInsets;
      tIconButtonDefaultIconButtonConstraintsOn: ui.BoxConstraints;
      tIconButtonDefaultIconButtonColorOn: ui.Color;
      tIconButtonDefaultIconButtonDecorationOnHover: ui.BoxDecoration;
      tIconButtonDefaultIconButtonPaddingOnHover: ui.EdgeInsets;
      tIconButtonDefaultIconButtonConstraintsOnHover: ui.BoxConstraints;
      tIconButtonDefaultIconButtonTextStyleOnHover: ui.TextStyle;
      tIconButtonDefaultIconButtonColorOnHover: ui.Color;
      tInputFieldDefaultInputFieldHeightOn: number;
      tInputFieldDefaultInputFieldBackgroundColorOn: ui.Color;
      tInputFieldDefaultInputFieldPlaceHolderColorOn: ui.Color;
      tInputFieldDefaultInputFieldInActiveColorOn: ui.Color;
      tInputFieldDefaultInputFieldStyleOn: ui.TextStyle;
      tInputFieldDefaultInputFieldActiveColorOn: ui.Color;
      tInputFieldDefaultInputFieldPaddingOn: ui.EdgeInsets;
      tInputFieldDefaultInputFieldCornerRadiusOn: number;
      tBaseDefaultPopUpDecorationOn: ui.BoxDecoration;
      tTextViewDescriptionTextFontSizeOn: number;
      tTextViewDescriptionTextFontWeightOn: ui.FontWeight;
      tTextViewDisplayHeadingOneFontSizeOn: number;
      tTextViewDisplayHeadingOneMarginOn: ui.EdgeInsets;
      tTextViewDisplayHeadingOneFontWeightOn: ui.FontWeight;
      tTextViewDropDownBuilderTextColorOn: ui.Color;
      tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets;
      tTextViewErrorTextColorOn: ui.Color;
      tTextViewErrorTextTextAlignOn: ui.TextAlign;
      tTextViewErrorTextMarginOn: ui.EdgeInsets;
      tColumnFieldStyleCrossAxisAlignmentOn: ui.CrossAxisAlignment;
      tColumnFieldStyleMarginOn: ui.EdgeInsets;
      tTextViewHeaderTextFontSizeOn: number;
      tTextViewHeaderTextFontWeightOn: ui.FontWeight;
      tTextViewHeadlineFiveFontSizeOn: number;
      tTextViewHeadlineFiveFontWeightOn: ui.FontWeight;
      tTextViewHeadlineFourFontSizeOn: number;
      tTextViewHeadlineFourFontWeightOn: ui.FontWeight;
      tTextViewHeadlineOneFontSizeOn: number;
      tTextViewHeadlineOneFontWeightOn: ui.FontWeight;
      tTextViewHeadlineSixFontSizeOn: number;
      tTextViewHeadlineSixFontWeightOn: ui.FontWeight;
      tTextViewHeadlineThreeFontSizeOn: number;
      tTextViewHeadlineThreeFontWeightOn: ui.FontWeight;
      tTextViewHeadlineTwoFontSizeOn: number;
      tTextViewHeadlineTwoFontWeightOn: ui.FontWeight;
      tTextViewInfoTextFontSizeOn: number;
      tTextViewInfoTextFontWeightOn: ui.FontWeight;
      tColumnJobDetailCardDecorationOn: ui.BoxDecoration;
      tColumnJobDetailCardPaddingOn: ui.EdgeInsets;
      tColumnJobDetailsPopupBGPaddingOn: ui.EdgeInsets;
      tColumnJobDetailsPopupBGDecorationOn: ui.BoxDecoration;
      tTextViewLabelTextFontSizeOn: number;
      tTextViewLabelTextFontWeightOn: ui.FontWeight;
      tTextViewLabelTextColorOn: ui.Color;
      tBaseLightColorWithMarginDecorationOn: ui.BoxDecoration;
      tBaseLightColorWithMarginMarginOn: ui.EdgeInsets;
      tButtonLinkButtonTextStyleOn: ui.TextStyle;
      tButtonPlainPrimaryButtonPaddingOn: ui.EdgeInsets;
      tButtonPlainPrimaryButtonTextStyleOn: ui.TextStyle;
      tButtonPlainSecondaryButtonPaddingOn: ui.EdgeInsets;
      tButtonPlainSecondaryButtonTextStyleOn: ui.TextStyle;
      tButtonPlainSecondaryButtonPaddingOnHover: ui.EdgeInsets;
      tButtonPlainSecondaryButtonTextStyleOnHover: ui.TextStyle;
      tButtonPrimaryDecorationOn: ui.BoxDecoration;
      tButtonPrimaryPaddingOn: ui.EdgeInsets;
      tButtonPrimaryTextStyleOn: ui.TextStyle;
      tButtonPrimaryConstraintsOn: ui.BoxConstraints;
      tButtonPrimaryDecorationOnHover: ui.BoxDecoration;
      tButtonPrimaryPaddingOnHover: ui.EdgeInsets;
      tButtonPrimaryConstraintsOnHover: ui.BoxConstraints;
      tButtonPrimaryTextStyleOnHover: ui.TextStyle;
      tButtonPrimaryButtonDecorationOn: ui.BoxDecoration;
      tButtonPrimaryButtonHeightOn: number;
      tButtonPrimaryButtonPaddingOn: ui.EdgeInsets;
      tButtonPrimaryButtonTextStyleOn: ui.TextStyle;
      tButtonPrimaryButtonConstraintsOn: ui.BoxConstraints;
      tButtonPrimaryButtonDecorationOnHover: ui.BoxDecoration;
      tButtonPrimaryButtonPaddingOnHover: ui.EdgeInsets;
      tButtonPrimaryButtonHeightOnHover: number;
      tButtonPrimaryButtonConstraintsOnHover: ui.BoxConstraints;
      tButtonPrimaryButtonTextStyleOnHover: ui.TextStyle;
      tButtonPrimaryOutlineDecorationOn: ui.BoxDecoration;
      tButtonPrimaryOutlinePaddingOn: ui.EdgeInsets;
      tButtonPrimaryOutlineTextStyleOn: ui.TextStyle;
      tButtonPrimaryOutlineConstraintsOn: ui.BoxConstraints;
      tButtonPrimaryOutlinePaddingOnHover: ui.EdgeInsets;
      tButtonPrimaryOutlineDecorationOnHover: ui.BoxDecoration;
      tButtonPrimaryOutlineConstraintsOnHover: ui.BoxConstraints;
      tButtonPrimaryOutlineTextStyleOnHover: ui.TextStyle;
      tColumnProjectCardDecorationOn: ui.BoxDecoration;
      tColumnProjectCardPaddingOn: ui.EdgeInsets;
      tRowProjectCard2DecorationOn: ui.BoxDecoration;
      tRowProjectCard2PaddingOn: ui.EdgeInsets;
      tColumnResumeBGColorDecorationOn: ui.BoxDecoration;
      tColumnResumeBGColorPaddingOn: ui.EdgeInsets;
      tInputFieldSearchInputFieldInActiveColorOn: ui.Color;
      tInputFieldSearchInputFieldPlaceHolderColorOn: ui.Color;
      tInputFieldSearchInputFieldActiveColorOn: ui.Color;
      tInputFieldSearchInputFieldPaddingOn: ui.EdgeInsets;
      tInputFieldSearchInputFieldCornerRadiusOn: number;
      tButtonSecondaryDecorationOn: ui.BoxDecoration;
      tButtonSecondaryPaddingOn: ui.EdgeInsets;
      tButtonSecondaryConstraintsOn: ui.BoxConstraints;
      tButtonSecondaryTextStyleOn: ui.TextStyle;
      tButtonSecondaryDecorationOnHover: ui.BoxDecoration;
      tButtonSecondaryPaddingOnHover: ui.EdgeInsets;
      tButtonSecondaryConstraintsOnHover: ui.BoxConstraints;
      tButtonSecondaryTextStyleOnHover: ui.TextStyle;
      tBaseSelectedTabContainerHeightOn: number;
      tBaseSelectedTabContainerWidthOn: number;
      tBaseSelectedTabContainerDecorationOn: ui.BoxDecoration;
      tBaseShadowForContainerDecorationOn: ui.BoxDecoration;
      tBaseShadowStyleDecorationOn: ui.BoxDecoration;
      tTextViewTabsFontSizeOn: number;
      tTextViewTabsFontWeightOn: ui.FontWeight;
      tButtonUnderLineButtonTextStyleOn: ui.TextStyle;
      tBaseViewPaddingPaddingOn: ui.EdgeInsets;
      tButtonWarningButtonDecorationOn: ui.BoxDecoration;
      tButtonWarningButtonPaddingOn: ui.EdgeInsets;
      tButtonWarningButtonTextStyleOn: ui.TextStyle;
      tButtonWarningButtonConstraintsOn: ui.BoxConstraints;
      tButtonWarningButtonDecorationOnHover: ui.BoxDecoration;
      tButtonWarningButtonPaddingOnHover: ui.EdgeInsets;
      tButtonWarningButtonConstraintsOnHover: ui.BoxConstraints;
      tButtonWarningButtonTextStyleOnHover: ui.TextStyle;
      tBaseWebBetweenMarginMarginOn: ui.EdgeInsets;
      tBaseWebPaddingPaddingOn: ui.EdgeInsets;
      tBaseWidgetPaddingPaddingOn: ui.EdgeInsets;
      c1: ui.Color;
      c2: ui.Color;
      c3: ui.Color;
      c4: ui.Color;
      c5: ui.Color;
      c6: ui.Color;
      c7: ui.Color;
      c8: ui.Color;
      c9: ui.Color;
      c10: ui.Color;
      c11: ui.Color;
      c12: ui.Color;
      c13: ui.Color;
      c14: ui.Color;
      c15: ui.Color;
      c16: ui.Color;
      c17: ui.Color;
      c18: ui.Color;
      c19: ui.Color;
      c20: ui.Color;
      c21: ui.Color;
      c22: ui.Color;
      c23: ui.Color;
      c24: ui.Color;
      c25: ui.Color;
      c26: ui.Color;
      c27: ui.Color;
    }>
  ) {
    this.themeName = d3eParams?.themeName;

    this.color = d3eParams?.color;

    this.textStyle = d3eParams?.textStyle;

    this.tooltipBackgroundColor = d3eParams?.tooltipBackgroundColor;

    this.tooltipTextColor = d3eParams?.tooltipTextColor;

    this.tTextViewMapTextColorOn = d3eParams?.tTextViewMapTextColorOn;

    this.tTextViewMapTextFontSizeOn = d3eParams?.tTextViewMapTextFontSizeOn;

    this.tTextViewPickerTextColorOn = d3eParams?.tTextViewPickerTextColorOn;

    this.tTextViewPickerTextFontSizeOn =
      d3eParams?.tTextViewPickerTextFontSizeOn;

    this.tTextViewLauncherTextColorOn = d3eParams?.tTextViewLauncherTextColorOn;

    this.tTextViewLauncherTextFontSizeOn =
      d3eParams?.tTextViewLauncherTextFontSizeOn;

    this.tTextViewStripeBlueColorOn = d3eParams?.tTextViewStripeBlueColorOn;

    this.tTextViewStripeBlueFontSizeOn =
      d3eParams?.tTextViewStripeBlueFontSizeOn;

    this.tTextViewBlue11ColorOn = d3eParams?.tTextViewBlue11ColorOn;

    this.tTextViewBlue11FontSizeOn = d3eParams?.tTextViewBlue11FontSizeOn;

    this.tBaseBetweenMarginMarginOn = d3eParams?.tBaseBetweenMarginMarginOn;

    this.tBaseCardDecorationOn = d3eParams?.tBaseCardDecorationOn;

    this.tBaseCardMarginsMarginOn = d3eParams?.tBaseCardMarginsMarginOn;

    this.tBaseCardPaddingPaddingOn = d3eParams?.tBaseCardPaddingPaddingOn;

    this.tIconButtonDefaultIconButtonDecorationOn =
      d3eParams?.tIconButtonDefaultIconButtonDecorationOn;

    this.tIconButtonDefaultIconButtonPaddingOn =
      d3eParams?.tIconButtonDefaultIconButtonPaddingOn;

    this.tIconButtonDefaultIconButtonConstraintsOn =
      d3eParams?.tIconButtonDefaultIconButtonConstraintsOn;

    this.tIconButtonDefaultIconButtonColorOn =
      d3eParams?.tIconButtonDefaultIconButtonColorOn;

    this.tIconButtonDefaultIconButtonDecorationOnHover =
      d3eParams?.tIconButtonDefaultIconButtonDecorationOnHover;

    this.tIconButtonDefaultIconButtonPaddingOnHover =
      d3eParams?.tIconButtonDefaultIconButtonPaddingOnHover;

    this.tIconButtonDefaultIconButtonConstraintsOnHover =
      d3eParams?.tIconButtonDefaultIconButtonConstraintsOnHover;

    this.tIconButtonDefaultIconButtonTextStyleOnHover =
      d3eParams?.tIconButtonDefaultIconButtonTextStyleOnHover;

    this.tIconButtonDefaultIconButtonColorOnHover =
      d3eParams?.tIconButtonDefaultIconButtonColorOnHover;

    this.tInputFieldDefaultInputFieldHeightOn =
      d3eParams?.tInputFieldDefaultInputFieldHeightOn;

    this.tInputFieldDefaultInputFieldBackgroundColorOn =
      d3eParams?.tInputFieldDefaultInputFieldBackgroundColorOn;

    this.tInputFieldDefaultInputFieldPlaceHolderColorOn =
      d3eParams?.tInputFieldDefaultInputFieldPlaceHolderColorOn;

    this.tInputFieldDefaultInputFieldInActiveColorOn =
      d3eParams?.tInputFieldDefaultInputFieldInActiveColorOn;

    this.tInputFieldDefaultInputFieldStyleOn =
      d3eParams?.tInputFieldDefaultInputFieldStyleOn;

    this.tInputFieldDefaultInputFieldActiveColorOn =
      d3eParams?.tInputFieldDefaultInputFieldActiveColorOn;

    this.tInputFieldDefaultInputFieldPaddingOn =
      d3eParams?.tInputFieldDefaultInputFieldPaddingOn;

    this.tInputFieldDefaultInputFieldCornerRadiusOn =
      d3eParams?.tInputFieldDefaultInputFieldCornerRadiusOn;

    this.tBaseDefaultPopUpDecorationOn =
      d3eParams?.tBaseDefaultPopUpDecorationOn;

    this.tTextViewDescriptionTextFontSizeOn =
      d3eParams?.tTextViewDescriptionTextFontSizeOn;

    this.tTextViewDescriptionTextFontWeightOn =
      d3eParams?.tTextViewDescriptionTextFontWeightOn;

    this.tTextViewDisplayHeadingOneFontSizeOn =
      d3eParams?.tTextViewDisplayHeadingOneFontSizeOn;

    this.tTextViewDisplayHeadingOneMarginOn =
      d3eParams?.tTextViewDisplayHeadingOneMarginOn;

    this.tTextViewDisplayHeadingOneFontWeightOn =
      d3eParams?.tTextViewDisplayHeadingOneFontWeightOn;

    this.tTextViewDropDownBuilderTextColorOn =
      d3eParams?.tTextViewDropDownBuilderTextColorOn;

    this.tTextViewDropDownBuilderTextPaddingOn =
      d3eParams?.tTextViewDropDownBuilderTextPaddingOn;

    this.tTextViewErrorTextColorOn = d3eParams?.tTextViewErrorTextColorOn;

    this.tTextViewErrorTextTextAlignOn =
      d3eParams?.tTextViewErrorTextTextAlignOn;

    this.tTextViewErrorTextMarginOn = d3eParams?.tTextViewErrorTextMarginOn;

    this.tColumnFieldStyleCrossAxisAlignmentOn =
      d3eParams?.tColumnFieldStyleCrossAxisAlignmentOn;

    this.tColumnFieldStyleMarginOn = d3eParams?.tColumnFieldStyleMarginOn;

    this.tTextViewHeaderTextFontSizeOn =
      d3eParams?.tTextViewHeaderTextFontSizeOn;

    this.tTextViewHeaderTextFontWeightOn =
      d3eParams?.tTextViewHeaderTextFontWeightOn;

    this.tTextViewHeadlineFiveFontSizeOn =
      d3eParams?.tTextViewHeadlineFiveFontSizeOn;

    this.tTextViewHeadlineFiveFontWeightOn =
      d3eParams?.tTextViewHeadlineFiveFontWeightOn;

    this.tTextViewHeadlineFourFontSizeOn =
      d3eParams?.tTextViewHeadlineFourFontSizeOn;

    this.tTextViewHeadlineFourFontWeightOn =
      d3eParams?.tTextViewHeadlineFourFontWeightOn;

    this.tTextViewHeadlineOneFontSizeOn =
      d3eParams?.tTextViewHeadlineOneFontSizeOn;

    this.tTextViewHeadlineOneFontWeightOn =
      d3eParams?.tTextViewHeadlineOneFontWeightOn;

    this.tTextViewHeadlineSixFontSizeOn =
      d3eParams?.tTextViewHeadlineSixFontSizeOn;

    this.tTextViewHeadlineSixFontWeightOn =
      d3eParams?.tTextViewHeadlineSixFontWeightOn;

    this.tTextViewHeadlineThreeFontSizeOn =
      d3eParams?.tTextViewHeadlineThreeFontSizeOn;

    this.tTextViewHeadlineThreeFontWeightOn =
      d3eParams?.tTextViewHeadlineThreeFontWeightOn;

    this.tTextViewHeadlineTwoFontSizeOn =
      d3eParams?.tTextViewHeadlineTwoFontSizeOn;

    this.tTextViewHeadlineTwoFontWeightOn =
      d3eParams?.tTextViewHeadlineTwoFontWeightOn;

    this.tTextViewInfoTextFontSizeOn = d3eParams?.tTextViewInfoTextFontSizeOn;

    this.tTextViewInfoTextFontWeightOn =
      d3eParams?.tTextViewInfoTextFontWeightOn;

    this.tColumnJobDetailCardDecorationOn =
      d3eParams?.tColumnJobDetailCardDecorationOn;

    this.tColumnJobDetailCardPaddingOn =
      d3eParams?.tColumnJobDetailCardPaddingOn;

    this.tColumnJobDetailsPopupBGPaddingOn =
      d3eParams?.tColumnJobDetailsPopupBGPaddingOn;

    this.tColumnJobDetailsPopupBGDecorationOn =
      d3eParams?.tColumnJobDetailsPopupBGDecorationOn;

    this.tTextViewLabelTextFontSizeOn = d3eParams?.tTextViewLabelTextFontSizeOn;

    this.tTextViewLabelTextFontWeightOn =
      d3eParams?.tTextViewLabelTextFontWeightOn;

    this.tTextViewLabelTextColorOn = d3eParams?.tTextViewLabelTextColorOn;

    this.tBaseLightColorWithMarginDecorationOn =
      d3eParams?.tBaseLightColorWithMarginDecorationOn;

    this.tBaseLightColorWithMarginMarginOn =
      d3eParams?.tBaseLightColorWithMarginMarginOn;

    this.tButtonLinkButtonTextStyleOn = d3eParams?.tButtonLinkButtonTextStyleOn;

    this.tButtonPlainPrimaryButtonPaddingOn =
      d3eParams?.tButtonPlainPrimaryButtonPaddingOn;

    this.tButtonPlainPrimaryButtonTextStyleOn =
      d3eParams?.tButtonPlainPrimaryButtonTextStyleOn;

    this.tButtonPlainSecondaryButtonPaddingOn =
      d3eParams?.tButtonPlainSecondaryButtonPaddingOn;

    this.tButtonPlainSecondaryButtonTextStyleOn =
      d3eParams?.tButtonPlainSecondaryButtonTextStyleOn;

    this.tButtonPlainSecondaryButtonPaddingOnHover =
      d3eParams?.tButtonPlainSecondaryButtonPaddingOnHover;

    this.tButtonPlainSecondaryButtonTextStyleOnHover =
      d3eParams?.tButtonPlainSecondaryButtonTextStyleOnHover;

    this.tButtonPrimaryDecorationOn = d3eParams?.tButtonPrimaryDecorationOn;

    this.tButtonPrimaryPaddingOn = d3eParams?.tButtonPrimaryPaddingOn;

    this.tButtonPrimaryTextStyleOn = d3eParams?.tButtonPrimaryTextStyleOn;

    this.tButtonPrimaryConstraintsOn = d3eParams?.tButtonPrimaryConstraintsOn;

    this.tButtonPrimaryDecorationOnHover =
      d3eParams?.tButtonPrimaryDecorationOnHover;

    this.tButtonPrimaryPaddingOnHover = d3eParams?.tButtonPrimaryPaddingOnHover;

    this.tButtonPrimaryConstraintsOnHover =
      d3eParams?.tButtonPrimaryConstraintsOnHover;

    this.tButtonPrimaryTextStyleOnHover =
      d3eParams?.tButtonPrimaryTextStyleOnHover;

    this.tButtonPrimaryButtonDecorationOn =
      d3eParams?.tButtonPrimaryButtonDecorationOn;

    this.tButtonPrimaryButtonHeightOn = d3eParams?.tButtonPrimaryButtonHeightOn;

    this.tButtonPrimaryButtonPaddingOn =
      d3eParams?.tButtonPrimaryButtonPaddingOn;

    this.tButtonPrimaryButtonTextStyleOn =
      d3eParams?.tButtonPrimaryButtonTextStyleOn;

    this.tButtonPrimaryButtonConstraintsOn =
      d3eParams?.tButtonPrimaryButtonConstraintsOn;

    this.tButtonPrimaryButtonDecorationOnHover =
      d3eParams?.tButtonPrimaryButtonDecorationOnHover;

    this.tButtonPrimaryButtonPaddingOnHover =
      d3eParams?.tButtonPrimaryButtonPaddingOnHover;

    this.tButtonPrimaryButtonHeightOnHover =
      d3eParams?.tButtonPrimaryButtonHeightOnHover;

    this.tButtonPrimaryButtonConstraintsOnHover =
      d3eParams?.tButtonPrimaryButtonConstraintsOnHover;

    this.tButtonPrimaryButtonTextStyleOnHover =
      d3eParams?.tButtonPrimaryButtonTextStyleOnHover;

    this.tButtonPrimaryOutlineDecorationOn =
      d3eParams?.tButtonPrimaryOutlineDecorationOn;

    this.tButtonPrimaryOutlinePaddingOn =
      d3eParams?.tButtonPrimaryOutlinePaddingOn;

    this.tButtonPrimaryOutlineTextStyleOn =
      d3eParams?.tButtonPrimaryOutlineTextStyleOn;

    this.tButtonPrimaryOutlineConstraintsOn =
      d3eParams?.tButtonPrimaryOutlineConstraintsOn;

    this.tButtonPrimaryOutlinePaddingOnHover =
      d3eParams?.tButtonPrimaryOutlinePaddingOnHover;

    this.tButtonPrimaryOutlineDecorationOnHover =
      d3eParams?.tButtonPrimaryOutlineDecorationOnHover;

    this.tButtonPrimaryOutlineConstraintsOnHover =
      d3eParams?.tButtonPrimaryOutlineConstraintsOnHover;

    this.tButtonPrimaryOutlineTextStyleOnHover =
      d3eParams?.tButtonPrimaryOutlineTextStyleOnHover;

    this.tColumnProjectCardDecorationOn =
      d3eParams?.tColumnProjectCardDecorationOn;

    this.tColumnProjectCardPaddingOn = d3eParams?.tColumnProjectCardPaddingOn;

    this.tRowProjectCard2DecorationOn = d3eParams?.tRowProjectCard2DecorationOn;

    this.tRowProjectCard2PaddingOn = d3eParams?.tRowProjectCard2PaddingOn;

    this.tColumnResumeBGColorDecorationOn =
      d3eParams?.tColumnResumeBGColorDecorationOn;

    this.tColumnResumeBGColorPaddingOn =
      d3eParams?.tColumnResumeBGColorPaddingOn;

    this.tInputFieldSearchInputFieldInActiveColorOn =
      d3eParams?.tInputFieldSearchInputFieldInActiveColorOn;

    this.tInputFieldSearchInputFieldPlaceHolderColorOn =
      d3eParams?.tInputFieldSearchInputFieldPlaceHolderColorOn;

    this.tInputFieldSearchInputFieldActiveColorOn =
      d3eParams?.tInputFieldSearchInputFieldActiveColorOn;

    this.tInputFieldSearchInputFieldPaddingOn =
      d3eParams?.tInputFieldSearchInputFieldPaddingOn;

    this.tInputFieldSearchInputFieldCornerRadiusOn =
      d3eParams?.tInputFieldSearchInputFieldCornerRadiusOn;

    this.tButtonSecondaryDecorationOn = d3eParams?.tButtonSecondaryDecorationOn;

    this.tButtonSecondaryPaddingOn = d3eParams?.tButtonSecondaryPaddingOn;

    this.tButtonSecondaryConstraintsOn =
      d3eParams?.tButtonSecondaryConstraintsOn;

    this.tButtonSecondaryTextStyleOn = d3eParams?.tButtonSecondaryTextStyleOn;

    this.tButtonSecondaryDecorationOnHover =
      d3eParams?.tButtonSecondaryDecorationOnHover;

    this.tButtonSecondaryPaddingOnHover =
      d3eParams?.tButtonSecondaryPaddingOnHover;

    this.tButtonSecondaryConstraintsOnHover =
      d3eParams?.tButtonSecondaryConstraintsOnHover;

    this.tButtonSecondaryTextStyleOnHover =
      d3eParams?.tButtonSecondaryTextStyleOnHover;

    this.tBaseSelectedTabContainerHeightOn =
      d3eParams?.tBaseSelectedTabContainerHeightOn;

    this.tBaseSelectedTabContainerWidthOn =
      d3eParams?.tBaseSelectedTabContainerWidthOn;

    this.tBaseSelectedTabContainerDecorationOn =
      d3eParams?.tBaseSelectedTabContainerDecorationOn;

    this.tBaseShadowForContainerDecorationOn =
      d3eParams?.tBaseShadowForContainerDecorationOn;

    this.tBaseShadowStyleDecorationOn = d3eParams?.tBaseShadowStyleDecorationOn;

    this.tTextViewTabsFontSizeOn = d3eParams?.tTextViewTabsFontSizeOn;

    this.tTextViewTabsFontWeightOn = d3eParams?.tTextViewTabsFontWeightOn;

    this.tButtonUnderLineButtonTextStyleOn =
      d3eParams?.tButtonUnderLineButtonTextStyleOn;

    this.tBaseViewPaddingPaddingOn = d3eParams?.tBaseViewPaddingPaddingOn;

    this.tButtonWarningButtonDecorationOn =
      d3eParams?.tButtonWarningButtonDecorationOn;

    this.tButtonWarningButtonPaddingOn =
      d3eParams?.tButtonWarningButtonPaddingOn;

    this.tButtonWarningButtonTextStyleOn =
      d3eParams?.tButtonWarningButtonTextStyleOn;

    this.tButtonWarningButtonConstraintsOn =
      d3eParams?.tButtonWarningButtonConstraintsOn;

    this.tButtonWarningButtonDecorationOnHover =
      d3eParams?.tButtonWarningButtonDecorationOnHover;

    this.tButtonWarningButtonPaddingOnHover =
      d3eParams?.tButtonWarningButtonPaddingOnHover;

    this.tButtonWarningButtonConstraintsOnHover =
      d3eParams?.tButtonWarningButtonConstraintsOnHover;

    this.tButtonWarningButtonTextStyleOnHover =
      d3eParams?.tButtonWarningButtonTextStyleOnHover;

    this.tBaseWebBetweenMarginMarginOn =
      d3eParams?.tBaseWebBetweenMarginMarginOn;

    this.tBaseWebPaddingPaddingOn = d3eParams?.tBaseWebPaddingPaddingOn;

    this.tBaseWidgetPaddingPaddingOn = d3eParams?.tBaseWidgetPaddingPaddingOn;

    this.c1 = d3eParams?.c1;

    this.c2 = d3eParams?.c2;

    this.c3 = d3eParams?.c3;

    this.c4 = d3eParams?.c4;

    this.c5 = d3eParams?.c5;

    this.c6 = d3eParams?.c6;

    this.c7 = d3eParams?.c7;

    this.c8 = d3eParams?.c8;

    this.c9 = d3eParams?.c9;

    this.c10 = d3eParams?.c10;

    this.c11 = d3eParams?.c11;

    this.c12 = d3eParams?.c12;

    this.c13 = d3eParams?.c13;

    this.c14 = d3eParams?.c14;

    this.c15 = d3eParams?.c15;

    this.c16 = d3eParams?.c16;

    this.c17 = d3eParams?.c17;

    this.c18 = d3eParams?.c18;

    this.c19 = d3eParams?.c19;

    this.c20 = d3eParams?.c20;

    this.c21 = d3eParams?.c21;

    this.c22 = d3eParams?.c22;

    this.c23 = d3eParams?.c23;

    this.c24 = d3eParams?.c24;

    this.c25 = d3eParams?.c25;

    this.c26 = d3eParams?.c26;

    this.c27 = d3eParams?.c27;
  }
  public static createEdgeTheme(): StyleThemeData {
    StyleThemeData.EdgeTheme = new StyleThemeData({
      themeName: "EdgeTheme",
      color: new ui.Color(0xffffffff),
      textStyle: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Nunito Sans",
        fontSize: 14.0,
      }),
      tooltipBackgroundColor: new ui.Color(0xffffffff),
      tooltipTextColor: new ui.Color(0xff000000),
      tTextViewMapTextColorOn: new ui.Color(0xff4f9ee0),
      tTextViewMapTextFontSizeOn: 13.5,
      tTextViewPickerTextColorOn: new ui.Color(0xff4f9ee0),
      tTextViewPickerTextFontSizeOn: 13.5,
      tTextViewLauncherTextColorOn: new ui.Color(0xff4f9ee0),
      tTextViewLauncherTextFontSizeOn: 13.5,
      tTextViewStripeBlueColorOn: new ui.Color(0xff4f9ee0),
      tTextViewStripeBlueFontSizeOn: 13.5,
      tTextViewBlue11ColorOn: new ui.Color(0xffe71306),
      tTextViewBlue11FontSizeOn: 13.5,
      tBaseBetweenMarginMarginOn: ui.EdgeInsets.fromLTRB(
        0.0,
        0.0,
        0.0,
        5.0,
        new Map()
      ),
      tBaseCardDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: new ui.Border({
          top: new ui.BorderSide({
            color: new ui.Color(0xff0000),
            width: 1.0,
            style: ui.BorderStyle.solid,
          }),
          bottom: new ui.BorderSide({
            color: new ui.Color(0xff0000),
            width: 1.0,
            style: ui.BorderStyle.solid,
          }),
          left: new ui.BorderSide({
            color: new ui.Color(0xff0000),
            width: 1.0,
            style: ui.BorderStyle.solid,
          }),
          right: new ui.BorderSide({
            color: new ui.Color(0xff0000),
            width: 1.0,
            style: ui.BorderStyle.solid,
          }),
        }),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0xfff5f5f5),
            blurRadius: 2.0,
            spreadRadius: 3.0,
          }),
        ],
        borderRadius: ui.BorderRadius.circular(4.0),
        transitions: new Map(),
      }),
      tBaseCardMarginsMarginOn: ui.EdgeInsets.fromLTRB(
        3.0,
        3.0,
        3.0,
        7.0,
        new Map()
      ),
      tBaseCardPaddingPaddingOn: ui.EdgeInsets.all(15.0, new Map()),
      tIconButtonDefaultIconButtonDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tIconButtonDefaultIconButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tIconButtonDefaultIconButtonConstraintsOn: new ui.BoxConstraints({
        minHeight: 30.0,
      }),
      tIconButtonDefaultIconButtonColorOn: new ui.Color(0xff686b78),
      tIconButtonDefaultIconButtonDecorationOnHover: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tIconButtonDefaultIconButtonPaddingOnHover: ui.EdgeInsets.all(
        7.0,
        new Map()
      ),
      tIconButtonDefaultIconButtonConstraintsOnHover: new ui.BoxConstraints({
        minHeight: 30.0,
      }),
      tIconButtonDefaultIconButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontFamily: "Nunito Sans",
      }),
      tIconButtonDefaultIconButtonColorOnHover: new ui.Color(0xffc20f2f),
      tInputFieldDefaultInputFieldHeightOn: 45.0,
      tInputFieldDefaultInputFieldBackgroundColorOn: new ui.Color(0xffffffff),
      tInputFieldDefaultInputFieldPlaceHolderColorOn: new ui.Color(0xffb4b4b4),
      tInputFieldDefaultInputFieldInActiveColorOn: new ui.Color(0xffd2d2d2),
      tInputFieldDefaultInputFieldStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff000000),
        fontFamily: "Nunito Sans",
      }),
      tInputFieldDefaultInputFieldActiveColorOn: new ui.Color(0xff4f9ee0),
      tInputFieldDefaultInputFieldPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 10.0,
        vertical: 0.0,
        transitions: new Map(),
      }),
      tInputFieldDefaultInputFieldCornerRadiusOn: 4.0,
      tBaseDefaultPopUpDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        borderRadius: ui.BorderRadius.circular(2.0),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0x32000000),
            blurRadius: 5.0,
          }),
        ],
        transitions: new Map(),
      }),
      tTextViewDescriptionTextFontSizeOn: 14.0,
      tTextViewDescriptionTextFontWeightOn: ui.FontWeight.w400,
      tTextViewDisplayHeadingOneFontSizeOn: 32.0,
      tTextViewDisplayHeadingOneMarginOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 10.0,
        transitions: new Map(),
      }),
      tTextViewDisplayHeadingOneFontWeightOn: ui.FontWeight.w800,
      tTextViewDropDownBuilderTextColorOn: new ui.Color(0xff000000),
      tTextViewDropDownBuilderTextPaddingOn: ui.EdgeInsets.fromLTRB(
        5.0,
        4.0,
        0.0,
        4.0,
        new Map()
      ),
      tTextViewErrorTextColorOn: new ui.Color(0xffc20f2f),
      tTextViewErrorTextTextAlignOn: ui.TextAlign.start,
      tTextViewErrorTextMarginOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tColumnFieldStyleCrossAxisAlignmentOn: ui.CrossAxisAlignment.start,
      tColumnFieldStyleMarginOn: ui.EdgeInsets.fromLTRB(
        0.0,
        8.0,
        0.0,
        0.0,
        new Map()
      ),
      tTextViewHeaderTextFontSizeOn: 30.0,
      tTextViewHeaderTextFontWeightOn: ui.FontWeight.w900,
      tTextViewHeadlineFiveFontSizeOn: 16.0,
      tTextViewHeadlineFiveFontWeightOn: ui.FontWeight.w500,
      tTextViewHeadlineFourFontSizeOn: 16.0,
      tTextViewHeadlineFourFontWeightOn: ui.FontWeight.w600,
      tTextViewHeadlineOneFontSizeOn: 24.0,
      tTextViewHeadlineOneFontWeightOn: ui.FontWeight.w900,
      tTextViewHeadlineSixFontSizeOn: 14.0,
      tTextViewHeadlineSixFontWeightOn: ui.FontWeight.w500,
      tTextViewHeadlineThreeFontSizeOn: 18.0,
      tTextViewHeadlineThreeFontWeightOn: ui.FontWeight.w600,
      tTextViewHeadlineTwoFontSizeOn: 20.0,
      tTextViewHeadlineTwoFontWeightOn: ui.FontWeight.w800,
      tTextViewInfoTextFontSizeOn: 14.0,
      tTextViewInfoTextFontWeightOn: ui.FontWeight.w600,
      tColumnJobDetailCardDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0x40000000),
            offset: ui.OffsetExt.getOffset({ dx: 0.0, dy: 0.0 }),
            blurRadius: 8.0,
            spreadRadius: 1.0,
          }),
        ],
        borderRadius: ui.BorderRadius.circular(6.0),
        transitions: new Map(),
      }),
      tColumnJobDetailCardPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 15.0,
        vertical: 20.0,
        transitions: new Map(),
      }),
      tColumnJobDetailsPopupBGPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 20.0,
        vertical: 40.0,
        transitions: new Map(),
      }),
      tColumnJobDetailsPopupBGDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tTextViewLabelTextFontSizeOn: 14.0,
      tTextViewLabelTextFontWeightOn: ui.FontWeight.w500,
      tTextViewLabelTextColorOn: new ui.Color(0xff3d3d3d),
      tBaseLightColorWithMarginDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xfff3f6f9),
        transitions: new Map(),
      }),
      tBaseLightColorWithMarginMarginOn: ui.EdgeInsets.fromLTRB(
        8.0,
        0.0,
        8.0,
        8.0,
        new Map()
      ),
      tButtonLinkButtonTextStyleOn: new ui.TextStyle({
        fontSize: 12.0,
        fontWeight: ui.FontWeight.w600,
        color: new ui.Color(0xffc20f2f),
        fontFamily: "Nunito Sans",
      }),
      tButtonPlainPrimaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPlainPrimaryButtonTextStyleOn: new ui.TextStyle({
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w600,
        color: new ui.Color(0xffc20f2f),
        fontFamily: "Nunito Sans",
      }),
      tButtonPlainSecondaryButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPlainSecondaryButtonTextStyleOn: new ui.TextStyle({
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xff686b78),
        fontFamily: "Nunito Sans",
      }),
      tButtonPlainSecondaryButtonPaddingOnHover: ui.EdgeInsets.all(
        7.0,
        new Map()
      ),
      tButtonPlainSecondaryButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 20.0,
        fontWeight: ui.FontWeight.w500,
        decoration: ui.TextDecoration.underline,
        fontFamily: "Nunito Sans",
      }),
      tButtonPrimaryDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffc20f2f), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xffc20f2f),
        transitions: new Map(),
      }),
      tButtonPrimaryPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPrimaryTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tButtonPrimaryConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonPrimaryDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff9b0a24), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xff9b0a24),
        transitions: new Map(),
      }),
      tButtonPrimaryPaddingOnHover: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPrimaryConstraintsOnHover: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonPrimaryTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tButtonPrimaryButtonDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffc20f2f), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xffc20f2f),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonHeightOn: 40.0,
      tButtonPrimaryButtonPaddingOn: ui.EdgeInsets.all(10.0, new Map()),
      tButtonPrimaryButtonTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tButtonPrimaryButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonPrimaryButtonDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff9b0a24), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xff9b0a24),
        transitions: new Map(),
      }),
      tButtonPrimaryButtonPaddingOnHover: ui.EdgeInsets.all(10.0, new Map()),
      tButtonPrimaryButtonHeightOnHover: 40.0,
      tButtonPrimaryButtonConstraintsOnHover: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonPrimaryButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffffffff),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tButtonPrimaryOutlineDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffc20f2f), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tButtonPrimaryOutlinePaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPrimaryOutlineTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xffc20f2f),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tButtonPrimaryOutlineConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonPrimaryOutlinePaddingOnHover: ui.EdgeInsets.all(7.0, new Map()),
      tButtonPrimaryOutlineDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xffc20f2f), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xffeeeef2),
        transitions: new Map(),
      }),
      tButtonPrimaryOutlineConstraintsOnHover: new ui.BoxConstraints({
        minHeight: 45.0,
        minWidth: 110.0,
      }),
      tButtonPrimaryOutlineTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xffc20f2f),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tColumnProjectCardDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0x40000000),
            offset: ui.OffsetExt.getOffset({ dx: 0.0, dy: 0.0 }),
            blurRadius: 8.0,
            spreadRadius: 1.0,
          }),
        ],
        borderRadius: ui.BorderRadius.circular(6.0),
        transitions: new Map(),
      }),
      tColumnProjectCardPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 15.0,
        vertical: 20.0,
        transitions: new Map(),
      }),
      tRowProjectCard2DecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        border: ui.Border.all({ color: new ui.Color(0xffffffff), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(6.0),
        transitions: new Map(),
      }),
      tRowProjectCard2PaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 5.0,
        transitions: new Map(),
      }),
      tColumnResumeBGColorDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tColumnResumeBGColorPaddingOn: ui.EdgeInsets.all(20.0, new Map()),
      tInputFieldSearchInputFieldInActiveColorOn: new ui.Color(0xff0000),
      tInputFieldSearchInputFieldPlaceHolderColorOn: new ui.Color(0xffb4b4b4),
      tInputFieldSearchInputFieldActiveColorOn: new ui.Color(0xff0000),
      tInputFieldSearchInputFieldPaddingOn: ui.EdgeInsets.fromLTRB(
        0.0,
        4.0,
        2.0,
        4.0,
        new Map()
      ),
      tInputFieldSearchInputFieldCornerRadiusOn: 4.0,
      tButtonSecondaryDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff686b78), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0xfda02c1f),
        transitions: new Map(),
      }),
      tButtonSecondaryPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonSecondaryTextStyleOn: new ui.TextStyle({
        color: new ui.Color(0xff686b78),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tButtonSecondaryDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xff686b78), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(4.0),
        color: new ui.Color(0x0),
        transitions: new Map(),
      }),
      tButtonSecondaryPaddingOnHover: ui.EdgeInsets.all(7.0, new Map()),
      tButtonSecondaryConstraintsOnHover: new ui.BoxConstraints({
        minHeight: 45.0,
        minWidth: 110.0,
      }),
      tButtonSecondaryTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0xff686b78),
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        fontFamily: "Nunito Sans",
      }),
      tBaseSelectedTabContainerHeightOn: 2.5,
      tBaseSelectedTabContainerWidthOn: 35.0,
      tBaseSelectedTabContainerDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffc20f2f),
        borderRadius: ui.BorderRadius.circular(5.0),
        transitions: new Map(),
      }),
      tBaseShadowForContainerDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0xfff5f5f5), width: 1.0 }),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0xffeeeef2),
            offset: ui.OffsetExt.getOffset({ dx: 0.0, dy: 0.0 }),
            blurRadius: 2.0,
            spreadRadius: 2.0,
          }),
        ],
        transitions: new Map(),
      }),
      tBaseShadowStyleDecorationOn: new ui.BoxDecoration({
        color: new ui.Color(0xffffffff),
        boxShadow: [
          new ui.BoxShadow({
            color: new ui.Color(0xffd2d2d2),
            blurRadius: 5.0,
            spreadRadius: 1.0,
            offset: ui.OffsetExt.getOffset({ dx: 1.0, dy: 1.0 }),
          }),
        ],
        borderRadius: ui.BorderRadius.circular(4.0),
        transitions: new Map(),
      }),
      tTextViewTabsFontSizeOn: 16.0,
      tTextViewTabsFontWeightOn: ui.FontWeight.bold,
      tButtonUnderLineButtonTextStyleOn: new ui.TextStyle({
        decoration: ui.TextDecoration.underline,
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w500,
        color: new ui.Color(0xffc20f2f),
        fontFamily: "Nunito Sans",
      }),
      tBaseViewPaddingPaddingOn: ui.EdgeInsets.symmetric({
        horizontal: 12.0,
        vertical: 8.0,
        transitions: new Map(),
      }),
      tButtonWarningButtonDecorationOn: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0x829f83bc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(6.0),
        color: new ui.Color(0x829f83bc),
        transitions: new Map(),
      }),
      tButtonWarningButtonPaddingOn: ui.EdgeInsets.all(7.0, new Map()),
      tButtonWarningButtonTextStyleOn: new ui.TextStyle({
        fontSize: 16.0,
        fontWeight: ui.FontWeight.w600,
        color: new ui.Color(0xffffffff),
        fontFamily: "Nunito Sans",
      }),
      tButtonWarningButtonConstraintsOn: new ui.BoxConstraints({
        minWidth: 110.0,
        minHeight: 45.0,
      }),
      tButtonWarningButtonDecorationOnHover: new ui.BoxDecoration({
        border: ui.Border.all({ color: new ui.Color(0x829f83bc), width: 1.0 }),
        borderRadius: ui.BorderRadius.circular(6.0),
        color: new ui.Color(0xffffffff),
        transitions: new Map(),
      }),
      tButtonWarningButtonPaddingOnHover: ui.EdgeInsets.all(7.0, new Map()),
      tButtonWarningButtonConstraintsOnHover: new ui.BoxConstraints({
        minHeight: 45.0,
        minWidth: 110.0,
      }),
      tButtonWarningButtonTextStyleOnHover: new ui.TextStyle({
        color: new ui.Color(0x829f83bc),
        fontFamily: "Nunito Sans",
      }),
      tBaseWebBetweenMarginMarginOn: ui.EdgeInsets.symmetric({
        horizontal: 0.0,
        vertical: 15.0,
        transitions: new Map(),
      }),
      tBaseWebPaddingPaddingOn: ui.EdgeInsets.all(35.0, new Map()),
      tBaseWidgetPaddingPaddingOn: ui.EdgeInsets.all(20.0, new Map()),
      c1: new ui.Color(0xffc20f2f),
      c2: new ui.Color(0xff9b0a24),
      c3: new ui.Color(0xff3e3d3d),
      c4: new ui.Color(0xff686b78),
      c5: new ui.Color(0xffffffff),
      c6: new ui.Color(0xff000000),
      c7: new ui.Color(0xffb4b4b4),
      c8: new ui.Color(0xff3d3d3d),
      c9: new ui.Color(0xffeeeef2),
      c10: new ui.Color(0xfff5f5f5),
      c11: new ui.Color(0xff585858),
      c12: new ui.Color(0xffd2d2d2),
      c13: new ui.Color(0xfffda02c),
      c14: new ui.Color(0xfda02c1f),
      c15: new ui.Color(0xff27b005),
      c16: new ui.Color(0xff4f9ee0),
      c17: new ui.Color(0xff0000),
      c18: new ui.Color(0xffffefef),
      c19: new ui.Color(0xff9f83bc),
      c20: new ui.Color(0x829f83bc),
      c21: new ui.Color(0xff64d7b8),
      c22: new ui.Color(0x8264d7b8),
      c23: new ui.Color(0xff64b7b8),
      c24: new ui.Color(0xffd85298),
      c25: new ui.Color(0xff616e7e),
      c26: new ui.Color(0xfff8f8f8),
      c27: new ui.Color(0xfff9f6f6),
    });

    return StyleThemeData.EdgeTheme;
  }
}

interface ThemeWrapperProps {
  child: ReactNode;
}

class _ThemeWrapper extends React.Component<ThemeWrapperProps> {
  public render(): React.ReactNode {
    DomUtils.loadTheme(StyleThemeData.current.themeName);

    return React.createElement(
      BuildContext.Provider,
      { value: { ...this.context, theme: StyleThemeData.current } },
      this.props.child
    );
  }
}
export default function ThemeWrapper(props: ThemeWrapperProps) {
  return React.createElement(_ThemeWrapper, props);
}

export const ThemeContext = React.createContext<StyleThemeData>(null);
